import { render, staticRenderFns } from "./BackupModal.vue?vue&type=template&id=2bc6d375&scoped=true&"
import script from "./BackupModal.vue?vue&type=script&lang=js&"
export * from "./BackupModal.vue?vue&type=script&lang=js&"
import style0 from "./BackupModal.vue?vue&type=style&index=0&id=2bc6d375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6d375",
  null
  
)

export default component.exports